import { SiloAsset } from 'app/queries/decoratedSilo';
import { Asset, LTV } from './types';
import { ChecksumAddress, getChecksumAddressOrThrow } from '@silo/types';
import { MainnetTokenAddress } from '@silo/addresses';

/**
 * Finds associated LTV asset from a silo asset
 */
export const getAssociatedAsset = <T extends Asset>(assets: T[], siloAsset: SiloAsset): T | undefined =>
  assets.find((asset) => asset.assetAddress === siloAsset.assetAddress);

export const getCountOfActiveDebtAssets = ({ debtAssets }: LTV): number =>
  debtAssets.filter(({ borrowedTokens }) => borrowedTokens > 0n).length;

export const TEST_ADDRESSES: Record<string, ChecksumAddress> = {
  USDC: MainnetTokenAddress.USDC,
  ETH: MainnetTokenAddress.WETH,
  APE: MainnetTokenAddress.APE,
  WBTC: MainnetTokenAddress.WBTC,
  DOGE: getChecksumAddressOrThrow('0x2a98f128092aBBadef25d17910EbE15B8495D0c1'),
};
